export function getChildComponents(currentComponent: any): any {
	if (currentComponent.formJson != null) {
		return getChildComponents(currentComponent.formJson);
	}

	return currentComponent.components ?? [];
}
